export const HEALTH_HISTORY_ADULT_SURVEY_SYSTEM_NAME = '1';
export const HEALTH_HISTORY_PEDIATRIC_SURVEY_SYSTEM_NAME = '2';
